export default {
  namespaced: true,
  state: {
    userData: [],
    myErrors: [],
    errorMsg: '',
    stepLogin: 0,
    rolesAdmitted: ['access_token', 'ur_part', 'ur_modulo', 'ur_risorsa', 'ur_deadline', 'ur_sidebar', 'ur_user_id', 'ur_email', 'ur_type'],

  },
  getters: {},
  mutations: {
    SET_DATA(state, data) {
      eval("state." + data.name + " = data.data;");
    }
  },


  actions: {

    checkStats(state) {

      axios.post('/oauth/token', {
        client_id: 12,
        client_secret: 'o5cRGnNi9ZcbQxwZkhEmWN9X4tlYKBRSNbtMqEHA',
        grant_type: 'client_credentials',
        scope: '*',
      })
        .then(response => {

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
          axios.defaults.headers.post['Accept'] = 'application/json';
          axios.get('api/v1/track/rep/activeUser')
            .then(response => {
              console.log(response.data)
            })
        })
    },

    checkLogin(state, payload) {
      state.commit('SET_DATA', {name: 'stepLogin', data: 1});
      state.commit('SET_DATA', {name: 'errorMsg', data: ''});
      state.dispatch('checkTeamMember', payload);
    },

    checkTeamMember(state, payload) {
      state.dispatch('destroyToken');
      axios.post('/oauth/token', {
        username: payload.email,
        password: payload.password,
        client_id: 2,
        client_secret: 'lZxWNLjGz7eHmc0Ner4ILkQDj0y5a6Y8Tolz8r7i',
        grant_type: 'password'
      })
        .then(response => {
          localStorage.setItem("access_token", response.data.access_token);
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;

          if (payload.email === 'supercoach@alfiobardolla.com') {
            window.location.href = '/login_cr'; // Avoid WordPress
          }
          axios.get('api/v1/user/checkTypeMember')
            .then(response => {
              if (response.data.type === 100 || response.data.type === 99 || response.data.type === 98 || response.data.force === 1) {
                window.location.href = '/login_cr'; // Avoid WordPress
              } else {
                state.dispatch('checkWPLogin', payload); // check on Wordpress
              }
            })
        })
        .catch(() => {
          state.dispatch('checkWPLogin', payload);
        })
    },

    destroyToken(state) {
      for (let i = 0; i < state.state.rolesAdmitted.length; i++) {
        localStorage.removeItem(state.state.rolesAdmitted[i]);
      }
    },

    checkWPLogin(state, payload) {
      let language = localStorage.getItem('language');
      if(language === null)
      {
        localStorage.setItem('language', 'it');
      }

      axios.post('/api/v1/wpauth', {
        email: payload.email,
        password: payload.password,
        language: localStorage.getItem('language'),
      })
        .then(response => {
          if (response.data !== false) {
            state.dispatch('registerUser', {userData: payload, restOfData: response.data});
          } else {
            state.commit('SET_DATA', {name: 'stepLogin', data: 0});
            state.commit('SET_DATA', {name: 'errorMsg', data: 'Ooops! Email o Password errati.'});
          }
        })
        .catch((error) => {
          state.commit('SET_DATA', {name: 'stepLogin', data: 0});
          state.commit('SET_DATA', {name: 'errorMsg', data: 'Ooops!! Email o Password errati.'});
          axios.post('/api/v2/track/saveError', {
            email: payload.email, description: error.response.data.exception +
              '\n' + error.response.data.file + '\n' + error.response.data.line
            , page: '/login', 'comment': 'n_user.js/checkWpLogin'
          })
        })
    },

    registerUser(state, payload) {
      axios.post('api/v1/user/register', payload)
        .then(response => {
          if (response.data.result === false) {
            state.commit('SET_DATA', {name: 'stepLogin', data: 0});
            state.commit('SET_DATA', {
              name: 'errorMsg',
              data: 'Ooops! Non sei abilitato a Real Estate Pro oppure il tuo pacchetto è scaduto.'
            })
          } else {
            state.dispatch('checkPassportLogin', payload.userData);
          }
        })
        .catch(error => {
          axios.post('/api/v2/track/saveError', {
            email: payload.email, description: error.response.data.exception +
              '\n' + error.response.data.file + '\n' + error.response.data.line
            , page: '/login', 'comment': 'n_user.js/registerUser'
          })
        })
    },

    checkPassportLogin(state, payload) {
      state.dispatch('destroyToken');
      axios.post('/oauth/token', {
        username: payload.email,
        password: payload.password,
        client_id: 2,
        client_secret: 'lZxWNLjGz7eHmc0Ner4ILkQDj0y5a6Y8Tolz8r7i',
        grant_type: 'password'
      })
        .then(response => {
          localStorage.setItem("access_token", response.data.access_token);
          window.location.href = '/login_cr';
        })
        .catch(error => {
          axios.post('/api/v2/track/saveError', {
            email: payload.email, description: error.response.data.exception +
              '\n' + error.response.data.file + '\n' + error.response.data.line
            , page: '/login', 'comment': 'n_user.js/checkPassportLogin'
          })
        })
    },

    isRemembered: function (state) {
      let result = 1;
      for (var i = 0; i < state.state.rolesAdmitted.length; i++) {
        if (localStorage.getItem(state.state.rolesAdmitted[i]) == undefined) {
          result = 0;
        }
      }
      if (result === 1) {
        state.dispatch('redirectUsingRole');
      }
    },

    redirectUsingRole() {
      let path = '';
      switch (parseInt(localStorage.getItem('ur_type'))) {
        case 100:
          path = '/adm/supercoach';
          break;
        case 98:
          path = '/adm/coach';
          break;
        default:
          path = '/dashboard';
          break;
      }
      window.location.href = path;
    },

    getUserRole(state) {

      axios.get('/api/v1/user/checkRole')
        .then(response => {
          localStorage.setItem("ur_part", JSON.stringify(response.data.part));
          localStorage.setItem("ur_modulo", JSON.stringify(response.data.modulo));
          localStorage.setItem("ur_risorsa", JSON.stringify(response.data.risorsa));
          localStorage.setItem("ur_sidebar", JSON.stringify(response.data.sidebar));
          localStorage.setItem("ur_deadline", JSON.stringify(response.data.deadline));
          localStorage.setItem('ur_user_id', JSON.stringify(response.data.user_id));
          localStorage.setItem('ur_email', JSON.stringify(response.data.email));
          localStorage.setItem('ur_type', JSON.stringify(response.data.type));
          state.dispatch('redirectUsingRole');
        }).catch(error => {
        if (error.response) {
          state.dispatch('checkErrorMessage', error.response);
          axios.post('/api/v2/track/saveError', {
            email: payload.email, description: error.response.data.exception +
              '\n' + error.response.data.file + '\n' + error.response.data.line
            , page: '/login', 'comment': 'n_user.js/getUserRole'
          })

        }
      });
    },

    checkErrorMessage(state, error) {
      if (error.status == 401) {
        state.dispatch('destroyToken');
        state.dispatch('redirectToLogin');
      }

    },

    redirectToLogin() {
      window.location.href = '/login';
    },

    getUserData(state) {
      axios.get('/api/v1/user')
        .then(function (response) {
          state.commit('SET_DATA', {name: 'userData', data: response.data});
					state.commit('n_mapping/SET_DATA', {name: 'userCountry', data: response.data.country}, {root: true});
        })
        .catch(() => {
          state.dispatch('destroyToken');
          state.dispatch('redirectToLogin');
        })
    },

    logout(state) {
      axios.get('/api/v1/user/logout')
        .then(() => {
          state.dispatch('destroyToken');
          state.dispatch('redirectToLogin');
        });
    },


    checkRealTimeExpiring(state) {
      if (localStorage.getItem('ur_type') != 98 && localStorage.getItem('ur_type') != 100) // coach
      {
        axios.get('/api/v1/user/checkRealTimeExpiring')
          .then(response => {
            if (response.data === -1) {
              state.dispatch('destroyToken');
              state.dispatch('redirectToLogin');
            }
          })
      }
    },

    unsubscribe(state, token) {
      axios.post('/api/v1/user/unsubscribe/', token);
    },

		activateDeactivateLinkCheck(state) {
			axios.get('/api/v1/user/activateDeactivateLinkCheck')
				.then(response => {
					state.commit('SET_DATA', {name: 'userData', data: response.data});
				});
		}
  }
}
